module.exports = __webpack_public_path__ + "img/713A28_A87661_3A160D_9B6454-256px.ac934e74.png";